import script from "./StatsEmployerQuery.vue?vue&type=script&lang=js"
export * from "./StatsEmployerQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__